import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20an%20open%20book%20floating%20in%20a%20magical%20cosmos%2C%20pages%20turning%20into%20beautiful%20flowing%20constellations%20and%20ink%20strokes%2C%20warm%20golden%20and%20deep%20crimson%20color%20palette%2C%20ethereal%20atmosphere%2C%20dreamy%20nebula%20background%2C%20abstract%20artistic%20style%2C%20soft%20gradient%20transitions%2C%20perfect%20for%20a%20webtoon%20reading%20platform%20hero%20background&width=1920&height=1080&seq=hero-bg-manhwa&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/70" />

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          探索无限韩漫世界
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          虚空韩漫网提供顺畅的韩漫在线阅读体验，聚合了韩国漫画网免费在线观看的韩国漫画，资源整合能力强。每日更新热门韩漫，涵盖浪漫爱情、奇幻冒险、热血动作等多种题材。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line mr-2"></i>
            开始阅读
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 text-white border border-white/30 font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-heart-line mr-2"></i>
            热门推荐
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">漫画资源</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">50万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">日访问用户</div>
          </div>
          <div className="w-px h-10 bg-white/20" />
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">8大</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">分类题材</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}